import {
    COLUMN_IDENTIFIERS,
    COLUMN_NAMES,
    COLUMN_RESOURCES,
    FEATURE_SETTINGS,
    InitialColumn,
    SORT_RESOURCES,
    USER_ACCESS_LEVELS
} from "..";

// Increase this number when changing the column structure
// (e.g. columns added/removed, default visibility changed, order updated).
// Used to reset columns stored in localStorage.
export const COLUMNS_SCHEMA_VERSION = 10;

export const TASK_GROUP_DETAILS_TASK_COLUMNS: InitialColumn[] = [
    {
        name: COLUMN_NAMES.Status,
        resource: COLUMN_RESOURCES.TaskStatusIcon,
        columnIdentifier: COLUMN_IDENTIFIERS.TaskStatusId,
        isDefaultActive: true,
        isDisabled: true,
        isSticky: true
    },
    {
        name: COLUMN_NAMES.TaskId,
        resource: COLUMN_RESOURCES.Id,
        isDefaultActive: true,
        sortResource: SORT_RESOURCES.Id
    },
    {
        name: COLUMN_NAMES.DeviceImei,
        resource: COLUMN_RESOURCES.DeviceImei,
        sortResource: SORT_RESOURCES.DeviceImei,
        isDefaultActive: true
    },
    {
        name: COLUMN_NAMES.LastStatusUpdate,
        resource: COLUMN_RESOURCES.StatusChangedAt,
        sortResource: SORT_RESOURCES.StatusChangedAt,
        isDefaultActive: true
    },
    {
        name: COLUMN_NAMES.Message,
        resource: COLUMN_RESOURCES.Message,
        isDefaultActive: true
    },
    {
        name: COLUMN_NAMES.DeviceCompany,
        resource: [COLUMN_RESOURCES.Company, COLUMN_RESOURCES.Name],
        sortResource: SORT_RESOURCES.CompanyName
    },
    {
        name: COLUMN_NAMES.Model,
        resource: [COLUMN_RESOURCES.Device, COLUMN_RESOURCES.Model]
    },
    {
        name: COLUMN_NAMES.CreatedBy,
        resource: [COLUMN_RESOURCES.CreatedBy, COLUMN_RESOURCES.Email]
    },
    {
        name: COLUMN_NAMES.UpdatedBy,
        resource: [COLUMN_RESOURCES.UpdatedBy, COLUMN_RESOURCES.Email],
        sortResource: SORT_RESOURCES.UpdatedBy
    },
    {
        name: COLUMN_NAMES.CreatedAt,
        resource: COLUMN_RESOURCES.CreatedAt,
        sortResource: SORT_RESOURCES.CreatedAt
    },
    {
        name: COLUMN_NAMES.UpdatedAt,
        resource: COLUMN_RESOURCES.UpdatedAt
    }
];

export const COMPANY_COLUMNS: InitialColumn[] = [
    {
        name: COLUMN_NAMES.Name,
        resource: COLUMN_RESOURCES.Name,
        sortResource: SORT_RESOURCES.Name,
        isDefaultActive: true,
        isDisabled: true,
        isSticky: true
    },
    {
        name: COLUMN_NAMES.Id,
        resource: COLUMN_RESOURCES.Id
    },
    {
        name: COLUMN_NAMES.ParentCompany,
        resource: [COLUMN_RESOURCES.Company, COLUMN_RESOURCES.Name],
        sortResource: SORT_RESOURCES.CompanyName,
        isDefaultActive: true
    },
    {
        name: COLUMN_NAMES.AccessGroup,
        resource: [COLUMN_RESOURCES.AccessGroup, COLUMN_RESOURCES.Name],
        isDefaultActive: true,
        accessLevelRequiredToRender: USER_ACCESS_LEVELS.Support
    },
    {
        name: COLUMN_NAMES.VipStatus,
        resource: COLUMN_RESOURCES.VipStatus,
        isDefaultActive: true,
        accessLevelRequiredToRender: USER_ACCESS_LEVELS.Support
    },
    {
        name: COLUMN_NAMES.GroupVipStatus,
        resource: COLUMN_RESOURCES.GroupVipStatus,
        isDefaultActive: true,
        accessLevelRequiredToRender: USER_ACCESS_LEVELS.Support
    },
    {
        name: COLUMN_NAMES.Type,
        resource: [COLUMN_RESOURCES.Type],
        accessLevelRequiredToRender: USER_ACCESS_LEVELS.Support
    },
    {
        name: COLUMN_NAMES.Code,
        resource: COLUMN_RESOURCES.Code,
        sortResource: SORT_RESOURCES.Code,
        isDefaultActive: true
    },
    {
        name: COLUMN_NAMES.CreatedBy,
        resource: [COLUMN_RESOURCES.CreatedBy, COLUMN_RESOURCES.Email],
        sortResource: SORT_RESOURCES.CreatedBy
    },
    {
        name: COLUMN_NAMES.CreatedAt,
        resource: COLUMN_RESOURCES.CreatedAt,
        sortResource: SORT_RESOURCES.CreatedAt
    }
];

export const DEVICE_COLUMNS: InitialColumn[] = [
    {
        name: COLUMN_NAMES.Imei,
        resource: COLUMN_RESOURCES.Imei,
        sortResource: SORT_RESOURCES.Imei,
        isDefaultActive: true,
        isDisabled: true,
        isSticky: true
    },
    {
        name: COLUMN_NAMES.Status,
        resource: COLUMN_RESOURCES.DeviceStatusIcon,
        columnIdentifier: COLUMN_IDENTIFIERS.DeviceActivityStatus,
        isDefaultActive: true,
        isDisabled: true
    },
    {
        name: COLUMN_NAMES.Queue,
        resource: COLUMN_RESOURCES.QueueIcon,
        columnIdentifier: COLUMN_IDENTIFIERS.DeviceTaskQueue,
        isDefaultActive: true
    },
    {
        name: COLUMN_NAMES.Description,
        resource: COLUMN_RESOURCES.Description,
        sortResource: SORT_RESOURCES.Description,
        isDefaultActive: true
    },
    {
        name: COLUMN_NAMES.Firmware,
        resource: COLUMN_RESOURCES.CurrentFirmware,
        sortResource: SORT_RESOURCES.CurrentFw,
        isDefaultActive: true
    },
    {
        name: COLUMN_NAMES.Configuration,
        resource: COLUMN_RESOURCES.CurrentConfiguration,
        sortResource: SORT_RESOURCES.CurrentCfg,
        isDefaultActive: true
    },
    {
        name: COLUMN_NAMES.ModemVersion,
        resource: COLUMN_RESOURCES.ModemVersion
    },
    {
        name: COLUMN_NAMES.Model,
        resource: COLUMN_RESOURCES.Model,
        sortResource: SORT_RESOURCES.Model,
        isDefaultActive: true
    },
    {
        name: COLUMN_NAMES.ModelPlatform,
        resource: COLUMN_RESOURCES.ModelPlatform,
        columnIdentifier: COLUMN_IDENTIFIERS.DevicesModelPlatform,
        isValueTranslatable: true
    },
    {
        name: COLUMN_NAMES.Serial,
        resource: COLUMN_RESOURCES.Serial,
        sortResource: SORT_RESOURCES.Serial
    },
    {
        name: COLUMN_NAMES.GsmNumber,
        resource: COLUMN_RESOURCES.GsmNumber
    },
    {
        name: COLUMN_NAMES.Iccid,
        resource: COLUMN_RESOURCES.Iccid
    },
    {
        name: COLUMN_NAMES.Imsi,
        resource: COLUMN_RESOURCES.Imsi
    },
    {
        name: COLUMN_NAMES.ProductCode,
        resource: COLUMN_RESOURCES.ProductCode
    },
    {
        name: COLUMN_NAMES.Company,
        resource: COLUMN_RESOURCES.CompanyName,
        sortResource: SORT_RESOURCES.CompanyName
    },
    {
        name: COLUMN_NAMES.Group,
        resource: COLUMN_RESOURCES.GroupName,
        sortResource: SORT_RESOURCES.GroupName
    },
    {
        name: COLUMN_NAMES.SeenAt,
        resource: COLUMN_RESOURCES.SeenAt,
        sortResource: SORT_RESOURCES.SeenAt,
        isDefaultActive: true
    },
    {
        name: COLUMN_NAMES.CreatedAt,
        resource: COLUMN_RESOURCES.CreatedAt,
        sortResource: SORT_RESOURCES.CreatedAt
    },
    {
        name: COLUMN_NAMES.UpdatedAt,
        resource: COLUMN_RESOURCES.UpdatedAt,
        sortResource: SORT_RESOURCES.UpdatedAt
    }
];

export const FILE_COLUMNS: InitialColumn[] = [
    {
        name: COLUMN_NAMES.Name,
        resource: COLUMN_RESOURCES.Name,
        sortResource: SORT_RESOURCES.Name,
        isDefaultActive: true,
        isDisabled: true,
        isSticky: true
    },
    {
        name: COLUMN_NAMES.Id,
        resource: COLUMN_RESOURCES.Id
    },
    {
        name: COLUMN_NAMES.Description,
        resource: COLUMN_RESOURCES.Description,
        sortResource: SORT_RESOURCES.Description,
        isDefaultActive: true
    },
    {
        name: COLUMN_NAMES.FileType,
        resource: COLUMN_RESOURCES.Type,
        sortResource: SORT_RESOURCES.Type,
        isDefaultActive: true,
        isValueTranslatable: true
    },
    {
        name: COLUMN_NAMES.Size,
        resource: COLUMN_RESOURCES.Size,
        sortResource: SORT_RESOURCES.Size,
        isDefaultActive: true
    },
    {
        name: COLUMN_NAMES.Company,
        resource: [COLUMN_RESOURCES.Company, COLUMN_RESOURCES.Name],
        sortResource: SORT_RESOURCES.CompanyName,
        isDefaultActive: true
    },
    {
        name: COLUMN_NAMES.CreatedBy,
        resource: COLUMN_RESOURCES.CreatedByEmail,
        sortResource: SORT_RESOURCES.CreatedByEmail
    },
    {
        name: COLUMN_NAMES.CreatedAt,
        resource: COLUMN_RESOURCES.CreatedAt,
        sortResource: SORT_RESOURCES.CreatedAt
    },
    {
        name: COLUMN_NAMES.LastUsedAt,
        resource: COLUMN_RESOURCES.LastUsedAt,
        isDefaultActive: true
    }
];

export const DEVICE_GROUP_COLUMNS: InitialColumn[] = [
    {
        name: COLUMN_NAMES.Name,
        resource: COLUMN_RESOURCES.Name,
        sortResource: SORT_RESOURCES.Name,
        isDefaultActive: true,
        isDisabled: true,
        isSticky: true
    },
    {
        name: COLUMN_NAMES.Id,
        resource: COLUMN_RESOURCES.Id
    },
    {
        name: COLUMN_NAMES.Company,
        resource: [COLUMN_RESOURCES.Company, COLUMN_RESOURCES.Name],
        sortResource: SORT_RESOURCES.CompanyName,
        isDefaultActive: true
    },
    {
        name: COLUMN_NAMES.CreatedAt,
        resource: COLUMN_RESOURCES.CreatedAt,
        sortResource: SORT_RESOURCES.CreatedAt
    }
];

export const USER_COLUMNS: InitialColumn[] = [
    {
        name: COLUMN_NAMES.Email,
        resource: COLUMN_RESOURCES.Email,
        sortResource: SORT_RESOURCES.Email,
        isDefaultActive: true,
        isDisabled: true,
        isSticky: true
    },
    {
        name: COLUMN_NAMES.Id,
        resource: COLUMN_RESOURCES.Id
    },
    {
        name: COLUMN_NAMES.Status,
        resource: COLUMN_RESOURCES.Status,
        columnIdentifier: COLUMN_IDENTIFIERS.UserStatus,
        isDefaultActive: true
    },
    {
        name: COLUMN_NAMES.Role,
        resource: COLUMN_RESOURCES.Roles,
        columnIdentifier: COLUMN_IDENTIFIERS.Roles,
        isDefaultActive: true
    },
    {
        name: COLUMN_NAMES.AccessGroup,
        resource: COLUMN_RESOURCES.AccessGroups,
        columnIdentifier: COLUMN_IDENTIFIERS.UserAccessGroups,
        isDefaultActive: true,
        accessLevelRequiredToRender: USER_ACCESS_LEVELS.Support
    },
    {
        name: COLUMN_NAMES.AccessLevel,
        resource: [COLUMN_RESOURCES.AccessLevel],
        isValueTranslatable: true,
        accessLevelRequiredToRender: USER_ACCESS_LEVELS.Support
    },
    {
        name: COLUMN_NAMES.Company,
        resource: [COLUMN_RESOURCES.Company, COLUMN_RESOURCES.Name],
        sortResource: SORT_RESOURCES.CompanyName,
        isDefaultActive: true
    },
    {
        name: COLUMN_NAMES.InvitedBy,
        resource: [COLUMN_RESOURCES.InvitedBy, COLUMN_RESOURCES.Email],
        sortResource: SORT_RESOURCES.InvitedBy
    },
    {
        name: COLUMN_NAMES.LastLoginAt,
        resource: COLUMN_RESOURCES.LastLoginAt,
        isDefaultActive: true
    },
    {
        name: COLUMN_NAMES.CreatedAt,
        resource: COLUMN_RESOURCES.CreatedAt,
        sortResource: SORT_RESOURCES.CreatedAt
    },
    {
        name: COLUMN_NAMES.UpdatedAt,
        resource: COLUMN_RESOURCES.UpdatedAt,
        sortResource: SORT_RESOURCES.UpdatedAt
    }
];

export const ROLE_AND_PERMISSION_COLUMNS: InitialColumn[] = [
    {
        name: COLUMN_NAMES.RoleName,
        resource: COLUMN_RESOURCES.Name,
        isDefaultActive: true,
        isDisabled: true,
        isSticky: true
    },
    {
        name: COLUMN_NAMES.Id,
        resource: COLUMN_RESOURCES.Id
    },
    {
        name: COLUMN_NAMES.Description,
        resource: COLUMN_RESOURCES.Description,
        isDefaultActive: true
    },
    {
        name: COLUMN_NAMES.Company,
        resource: [COLUMN_RESOURCES.Company, COLUMN_RESOURCES.Name],
        isDefaultActive: true
    },
    {
        name: COLUMN_NAMES.PermissionCount,
        resource: COLUMN_RESOURCES.Permissions,
        columnIdentifier: COLUMN_IDENTIFIERS.RolePermissions,
        isDefaultActive: true
    },
    {
        name: COLUMN_NAMES.CreatedAt,
        resource: COLUMN_RESOURCES.CreatedAt,
        sortResource: SORT_RESOURCES.CreatedAt,
        isDefaultActive: true
    },
    {
        name: COLUMN_NAMES.CreatedBy,
        resource: COLUMN_RESOURCES.CreatedByEmail,
        isDefaultActive: true
    },
    {
        name: COLUMN_NAMES.UpdatedAt,
        resource: COLUMN_RESOURCES.UpdatedAt,
        sortResource: SORT_RESOURCES.UpdatedAt
    },
    {
        name: COLUMN_NAMES.UpdatedBy,
        resource: COLUMN_RESOURCES.UpdatedByEmail
    }
];

export const PRODUCT_CODE_COLUMNS: InitialColumn[] = [
    {
        name: COLUMN_NAMES.ProductCode,
        resource: COLUMN_RESOURCES.ProductCode,
        sortResource: SORT_RESOURCES.ProductCode,
        isDefaultActive: true,
        isDisabled: true,
        isSticky: true
    },
    {
        name: COLUMN_NAMES.CanPackage,
        resource: [COLUMN_RESOURCES.CanPackage, COLUMN_RESOURCES.Name],
        sortResource: SORT_RESOURCES.CanPackage,
        isDefaultActive: true
    },
    {
        name: COLUMN_NAMES.CreatedAt,
        resource: COLUMN_RESOURCES.CreatedAt,
        sortResource: SORT_RESOURCES.CreatedAt,
        isDefaultActive: true
    },
    {
        name: COLUMN_NAMES.CreatedBy,
        resource: COLUMN_RESOURCES.CreatedByEmail,
        sortResource: SORT_RESOURCES.CreatedByEmail,
        isDefaultActive: true
    },
    {
        name: COLUMN_NAMES.UpdatedAt,
        resource: COLUMN_RESOURCES.UpdatedAt,
        sortResource: SORT_RESOURCES.UpdatedAt,
        isDefaultActive: true
    },
    {
        name: COLUMN_NAMES.UpdatedBy,
        resource: COLUMN_RESOURCES.UpdatedByEmail,
        sortResource: SORT_RESOURCES.UpdatedByEmail,
        isDefaultActive: true
    }
];

export const DESKTOP_LICENSE_COLUMNS: InitialColumn[] = [
    {
        name: COLUMN_NAMES.Name,
        resource: COLUMN_RESOURCES.Name,
        sortResource: SORT_RESOURCES.Name,
        isDefaultActive: true,
        isDisabled: true,
        isSticky: true
    },
    {
        name: COLUMN_NAMES.Company,
        resource: [COLUMN_RESOURCES.Company, COLUMN_RESOURCES.Name],
        sortResource: SORT_RESOURCES.CompanyName,
        isDefaultActive: true
    },
    {
        name: COLUMN_NAMES.Status,
        resource: COLUMN_RESOURCES.DesktopLicenseStatusIcon,
        columnIdentifier: COLUMN_IDENTIFIERS.DesktopLicenseStatus,
        sortResource: SORT_RESOURCES.Enabled,
        isDefaultActive: true
    },
    {
        name: COLUMN_NAMES.Expiration,
        resource: COLUMN_RESOURCES.ExpiresAt,
        sortResource: SORT_RESOURCES.ExpiresAt,
        customDateTimeFormat: "L",
        isDefaultActive: true
    },
    {
        name: COLUMN_NAMES.CreatedBy,
        resource: [COLUMN_RESOURCES.CreatedBy, COLUMN_RESOURCES.Email],
        sortResource: SORT_RESOURCES.CreatedBy,
        isDefaultActive: true
    },
    {
        name: COLUMN_NAMES.CreatedAt,
        resource: COLUMN_RESOURCES.CreatedAt,
        sortResource: SORT_RESOURCES.CreatedAt,
        isDefaultActive: true
    },
    {
        name: COLUMN_NAMES.LastCheckedAt,
        resource: COLUMN_RESOURCES.LastCheckedAt,
        sortResource: SORT_RESOURCES.LastCheckedAt,
        isDefaultActive: false
    }
];

export const DEVICE_DETAILS_CHANGES_COLUMNS: InitialColumn[] = [
    {
        name: COLUMN_NAMES.ChangedAt,
        resource: COLUMN_RESOURCES.CreatedAt,
        sortResource: SORT_RESOURCES.CreatedAt,
        isDefaultActive: true,
        isDisabled: true
    },
    {
        name: COLUMN_NAMES.Field,
        resource: COLUMN_RESOURCES.Attribute,
        isDefaultActive: true,
        isValueTranslatable: true
    },
    {
        name: COLUMN_NAMES.ValueFrom,
        resource: COLUMN_RESOURCES.Old,
        sortResource: SORT_RESOURCES.Old,
        isDefaultActive: true
    },
    {
        name: COLUMN_NAMES.ValueTo,
        resource: COLUMN_RESOURCES.New,
        sortResource: SORT_RESOURCES.New,
        isDefaultActive: true
    },
    {
        name: COLUMN_NAMES.CreatedBy,
        resource: COLUMN_RESOURCES.CreatedByEmail,
        isDefaultActive: true
    },
    {
        name: COLUMN_NAMES.Visibility,
        resource: COLUMN_RESOURCES.Visibility,
        columnIdentifier: COLUMN_IDENTIFIERS.Visibility,
        isDefaultActive: true,
        isDisabled: true,
        accessLevelRequiredToRender: USER_ACCESS_LEVELS.Support
    }
];

export const DEVICE_DETAILS_TASK_QUEUE_COLUMNS: InitialColumn[] = [
    {
        name: COLUMN_NAMES.Status,
        resource: COLUMN_RESOURCES.TaskStatusIcon,
        columnIdentifier: COLUMN_IDENTIFIERS.TaskStatusId,
        isDefaultActive: true,
        isDisabled: true,
        isSticky: true
    },
    {
        name: COLUMN_NAMES.BatchId,
        resource: COLUMN_RESOURCES.BatchId,
        isDefaultActive: true
    },
    {
        name: COLUMN_NAMES.TaskId,
        resource: COLUMN_RESOURCES.Id,
        sortResource: SORT_RESOURCES.Id,
        isDefaultActive: true
    },
    {
        name: COLUMN_NAMES.TaskType,
        resource: COLUMN_RESOURCES.Type,
        sortResource: SORT_RESOURCES.Type,
        isDefaultActive: true,
        isValueTranslatable: true
    },
    {
        name: COLUMN_NAMES.LastStatusUpdate,
        resource: COLUMN_RESOURCES.StatusChangedAt,
        sortResource: SORT_RESOURCES.StatusChangedAt,
        isDefaultActive: true
    },
    {
        name: COLUMN_NAMES.Message,
        resource: COLUMN_RESOURCES.Message,
        isDefaultActive: true
    },
    {
        name: COLUMN_NAMES.CreatedBy,
        resource: [COLUMN_RESOURCES.CreatedBy, COLUMN_RESOURCES.Email],
        sortResource: SORT_RESOURCES.CreatedBy
    },
    {
        name: COLUMN_NAMES.UpdatedBy,
        resource: [COLUMN_RESOURCES.UpdatedBy, COLUMN_RESOURCES.Email],
        sortResource: SORT_RESOURCES.UpdatedBy
    },
    {
        name: COLUMN_NAMES.CreatedAt,
        resource: COLUMN_RESOURCES.CreatedAt,
        sortResource: SORT_RESOURCES.CreatedAt
    },
    {
        name: COLUMN_NAMES.UpdatedAt,
        resource: COLUMN_RESOURCES.UpdatedAt
    },
    {
        name: COLUMN_NAMES.Schedule,
        resource: COLUMN_RESOURCES.Schedule,
        columnIdentifier: COLUMN_IDENTIFIERS.Schedule,
        isDefaultActive: true,
        restriction: FEATURE_SETTINGS.TaskScheduleSupport
    }
];

export const DEVICE_DETAILS_CONFIGURATION_OVERVIEW_COLUMNS: InitialColumn[] = [
    {
        name: COLUMN_NAMES.ConfigurationType,
        resource: COLUMN_RESOURCES.Type,
        columnIdentifier: COLUMN_IDENTIFIERS.ConfigurationType,
        isDefaultActive: true,
        isValueTranslatable: true
    },
    {
        name: COLUMN_NAMES.UserSentConfiguration,
        resource: COLUMN_RESOURCES.UserSentConfiguration,
        columnIdentifier: COLUMN_IDENTIFIERS.UserSentConfiguration,
        isDefaultActive: true
    },
    {
        name: COLUMN_NAMES.SyncMode,
        resource: COLUMN_RESOURCES.Type,
        columnIdentifier: COLUMN_IDENTIFIERS.SyncMode,
        isDefaultActive: true
    },
    {
        name: COLUMN_NAMES.Origin,
        resource: [
            COLUMN_RESOURCES.ConfigurationChange,
            COLUMN_RESOURCES.Origin
        ],
        isDefaultActive: true,
        isValueTranslatable: true
    },
    {
        name: COLUMN_NAMES.SyncedAt,
        resource: [
            COLUMN_RESOURCES.ConfigurationChange,
            COLUMN_RESOURCES.CreatedAt
        ],
        columnIdentifier: COLUMN_IDENTIFIERS.SyncedAt,
        isDefaultActive: true
    },
    {
        name: COLUMN_NAMES.SyncStatus,
        resource: COLUMN_RESOURCES.Type,
        columnIdentifier: COLUMN_IDENTIFIERS.SyncStatus,
        isDefaultActive: true
    }
];

export const DEVICE_DETAILS_CONFIGURATION_CHANGES_COLUMNS: InitialColumn[] = [
    {
        name: COLUMN_NAMES.ConfigurationType,
        resource: COLUMN_RESOURCES.Type,
        isDefaultActive: true,
        isDisabled: true,
        isValueTranslatable: true
    },
    {
        name: COLUMN_NAMES.ChangeOrigin,
        resource: COLUMN_RESOURCES.Origin,
        isDefaultActive: true,
        isValueTranslatable: true
    },
    {
        name: COLUMN_NAMES.SyncedAt,
        resource: COLUMN_RESOURCES.CreatedAt,
        columnIdentifier: COLUMN_IDENTIFIERS.SyncedAt,
        isDefaultActive: true
    },
    {
        name: COLUMN_NAMES.ChangedAt,
        resource: COLUMN_RESOURCES.ChangedAt,
        columnIdentifier: COLUMN_IDENTIFIERS.ConfigurationChangesChangedAt,
        isDefaultActive: true
    },
    {
        name: COLUMN_NAMES.DownloadAt,
        resource: [
            COLUMN_RESOURCES.Task,
            COLUMN_RESOURCES.File,
            COLUMN_RESOURCES.CreatedAt
        ],
        columnIdentifier: COLUMN_IDENTIFIERS.ConfigurationChangesDownloadAt,
        isDefaultActive: true
    }
];

export const DEVICE_GROUP_DETAILS_TASK_COLUMNS: InitialColumn[] = [
    ...DEVICE_DETAILS_TASK_QUEUE_COLUMNS.slice(0, 4),
    {
        name: COLUMN_NAMES.DeviceImei,
        resource: COLUMN_RESOURCES.DeviceImei,
        sortResource: SORT_RESOURCES.DeviceImei,
        isDefaultActive: true
    },
    ...DEVICE_DETAILS_TASK_QUEUE_COLUMNS.slice(4)
];

export const OFFLINE_LICENSE_COLUMNS: InitialColumn[] = [
    {
        name: COLUMN_NAMES.Name,
        resource: COLUMN_RESOURCES.Name,
        sortResource: SORT_RESOURCES.Name,
        isDefaultActive: true,
        isSticky: true
    },
    {
        name: COLUMN_NAMES.DevicesCount,
        resource: COLUMN_RESOURCES.DevicesCount,
        sortResource: SORT_RESOURCES.DevicesCount,
        isDefaultActive: true
    },
    {
        name: COLUMN_NAMES.ExpiresAt,
        resource: COLUMN_RESOURCES.ExpiresAt,
        sortResource: SORT_RESOURCES.ExpiresAt,
        customDateTimeFormat: "L",
        isDefaultActive: true
    },
    {
        name: COLUMN_NAMES.CreatedAt,
        resource: COLUMN_RESOURCES.CreatedAt,
        sortResource: SORT_RESOURCES.CreatedAt,
        isDefaultActive: true
    },
    {
        name: COLUMN_NAMES.CreatedBy,
        resource: COLUMN_RESOURCES.CreatedByEmail,
        sortResource: SORT_RESOURCES.CreatedByEmail,
        isDefaultActive: true
    }
];

export const MODEL_COLUMNS: InitialColumn[] = [
    {
        name: COLUMN_NAMES.Model,
        resource: COLUMN_RESOURCES.Name,
        isDefaultActive: true,
        isDisabled: true,
        isSticky: true
    },
    {
        name: COLUMN_NAMES.ModelPlatform,
        resource: COLUMN_RESOURCES.Platform,
        columnIdentifier: COLUMN_IDENTIFIERS.ModelsModelPlatform,
        isDefaultActive: true,
        isValueTranslatable: true
    },
    {
        name: COLUMN_NAMES.TctWebSupport,
        resource: COLUMN_RESOURCES.WebEditorSupport,
        columnIdentifier: COLUMN_IDENTIFIERS.WebEditorSupport,
        isDefaultActive: true
    },
    {
        name: COLUMN_NAMES.SupportedTaskTypes,
        resource: COLUMN_RESOURCES.TaskTypeCompatibilities,
        columnIdentifier: COLUMN_IDENTIFIERS.TaskTypeCompatibilities,
        isDefaultActive: true
    },
    {
        name: COLUMN_NAMES.CreatedAt,
        resource: COLUMN_RESOURCES.CreatedAt,
        sortResource: SORT_RESOURCES.CreatedAt,
        isDefaultActive: true
    }
];

export const COMPATIBILITY_COLUMNS: InitialColumn[] = [
    {
        name: COLUMN_NAMES.Model,
        resource: COLUMN_RESOURCES.ModelName,
        isDefaultActive: true,
        isDisabled: true,
        isSticky: true
    },
    {
        name: COLUMN_NAMES.TaskType,
        resource: COLUMN_RESOURCES.TaskType,
        isDefaultActive: true,
        isValueTranslatable: true
    },
    {
        name: COLUMN_NAMES.Status,
        resource: COLUMN_RESOURCES.TaskSupport,
        columnIdentifier: COLUMN_IDENTIFIERS.TaskSupport,
        isDefaultActive: true
    }
];
